'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function initial(arr) {
    return arr.slice(0, -1);
}

exports.initial = initial;
